import { render, staticRenderFns } from "./CtcRescheduleModal.vue?vue&type=template&id=01b610de&scoped=true&"
import script from "./CtcRescheduleModal.vue?vue&type=script&lang=js&"
export * from "./CtcRescheduleModal.vue?vue&type=script&lang=js&"
import style0 from "./CtcRescheduleModal.vue?vue&type=style&index=0&id=01b610de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b610de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
